// --- Reusable helpers ---
const _comp22Serializer = new XMLSerializer();
let _comp22HiddenTA;

const _comp22GetTA = () => {
    if (!_comp22HiddenTA) {
        _comp22HiddenTA = document.createElement("textarea");
        Object.assign(_comp22HiddenTA.style, {
            position: "fixed",
            opacity: "0",
            pointerEvents: "none",
            zIndex: "-1",
            top: "0",
            left: "0",
            width: "1px",
            height: "1px",
        });
        document.body.appendChild(_comp22HiddenTA);
    }
    return _comp22HiddenTA;
};

const _comp22Copy = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {}
    }
    const ta = _comp22GetTA();
    ta.value = text;
    ta.select();
    try {
        return document.execCommand("copy");
    } finally {
        ta.blur();
    }
};

// --- Main ---
function Comp22() {
    const ROOT = ".comp-22";
    const ITEM = ".comp-22-row-icons .comp-22-row-icons-item";

    const esc = (id) =>
        window.CSS && CSS.escape ? `#${CSS.escape(id)}` : `#${id}`;

    const findSVG = ($item, id) => {
        const sel = esc(id);
        let el = $item.find(sel).get(0) || $item.closest(ROOT).find(sel).get(0);
        if (!el) return null;
        if (el.tagName.toLowerCase() !== "svg") el = el.querySelector("svg");
        return el || null;
    };

    $(document)
        .off("click.comp22", ITEM)
        .on("click.comp22", ITEM, async (e) => {
            const id = e.currentTarget.dataset.target;
            if (!id) return;

            const svg = findSVG($(e.currentTarget), id);
            if (!svg) return;

            const node = svg.cloneNode(true);
            node.hasAttribute("xmlns") ||
                node.setAttribute("xmlns", "http://www.w3.org/2000/svg");

            if (
                !node.hasAttribute("xmlns:xlink") &&
                (node.hasAttribute("xlink:href") ||
                    node.querySelector("[xlink\\:href]"))
            ) {
                node.setAttribute(
                    "xmlns:xlink",
                    "http://www.w3.org/1999/xlink"
                );
            }

            if (
                (!node.getAttribute("width") || !node.getAttribute("height")) &&
                node.hasAttribute("viewBox")
            ) {
                const [, , w, h] = node
                    .getAttribute("viewBox")
                    .split(/\s+/)
                    .map(Number);
                node.getAttribute("width") || node.setAttribute("width", w);
                node.getAttribute("height") || node.setAttribute("height", h);
            }

            const svgText = _comp22Serializer.serializeToString(node);
            if (!svgText) return;

            if (await _comp22Copy(svgText)) {
                const a = document.querySelector(".copied-alert.svg");
                a?.classList.add("show");
                setTimeout(() => a?.classList.remove("show"), 2000);
            }
        });
}

Comp22();
